/** 项目模型上下文身份。 */
export interface ProjectModelContextIdentity {
  /** 项目 ID，用于区分不同项目空间。 */
  readonly projectId: string
  /** 仓库 ID，用于区分同一项目下的不同模型仓库。 */
  readonly repositoryId: string
  /** 分支 ID，用于区分同一仓库下的不同分支上下文。 */
  readonly branchId: string
  /** 提交 ID，用于区分同一分支上的不同 CAD 文档版本。 */
  readonly commitId: string
  /** 根节点 key，用于定位当前打开模型的根节点。 */
  readonly rootNodeKey: string
  /** 根包身份，用于区分根节点对应的 PuppyCAD 包内容。 */
  readonly rootPackageIdentity: string
  /** 打开项目会话 ID，用于区分同一项目模型的不同打开生命周期。 */
  readonly openProjectSessionId: string
}

/**
 * 创建项目模型上下文身份。
 *
 * @param input 项目模型上下文身份输入。
 * @returns 与输入字段一致的新身份对象。
 */
export function createProjectModelContextIdentity(
  input: ProjectModelContextIdentity,
): ProjectModelContextIdentity {
  return { ...input }
}

/**
 * 判断两个项目模型上下文是否完全一致。
 *
 * @param left 左侧项目模型上下文身份。
 * @param right 右侧项目模型上下文身份。
 * @returns 两侧身份存在且全部字段一致时返回 true。
 */
export function isSameProjectModelContextIdentity(
  left: ProjectModelContextIdentity | null | undefined,
  right: ProjectModelContextIdentity | null | undefined,
): boolean {
  return !!left
    && !!right
    && left.projectId === right.projectId
    && left.repositoryId === right.repositoryId
    && left.branchId === right.branchId
    && left.commitId === right.commitId
    && left.rootNodeKey === right.rootNodeKey
    && left.rootPackageIdentity === right.rootPackageIdentity
    && left.openProjectSessionId === right.openProjectSessionId
}

/** 项目模型缓存身份。 */
export interface ProjectModelCacheIdentity {
  /** 运行时缓存 key，用于区分当前进程内的缓存条目。 */
  readonly runtimeKey: string
  /** 完整项目模型上下文身份，用于避免跨项目或跨版本复用缓存。 */
  readonly projectModelContextIdentity: ProjectModelContextIdentity
}
